import { SearchEndpoint } from '@/docs-partials/clips';
import * as React from 'react';
export default {
  SearchEndpoint,
  React
};